/*
 App configuration
 */

import "./models/user.js";
import core from "./libs/core.js";
import menu from "./helpers/menu.js";
import locale from "./helpers/locale.js";
import theme from "./helpers/theme.js";
import authorizeForm from "./views/forms/authorize.js";
import user from "./models/portalUser.js";
import sysFunc from "./models/system/systemFunctions.js";
import "./models/TableModel/paramTableModel.js";
import { loadView } from "./helpers/viewLoader.js";
import webixNativeScroll from "./helpers/webixNativeScroll.mjs";

window.__loadView = loadView;

window.__showAuthorize = function () {
    if (webix.$$("userAddForm")) {
        return;
    }
    webix.ui(authorizeForm.$ui).show();
};

webix.env.cdn = "//cdn.webix.com";

// Deprecated #16008: non-report views only. Report pages use ReportShell (no horizontal filter scroll).
webix.wrapFilterScroll = webixNativeScroll.wrapFilterScroll;

// CKEditor requires full path
webix.codebase = document.location.href.split("#")[0].replace(/index(\.vite)?\.html/, "") + "libs/webix/";

//configuration
var testmode = 0;
var app = null;

webix.ready(function () {
    webix.Date.startOnMonday = true;

    // Webix mobile: fullScreen before webix.ui, Touch.limit for in-component pans.
    webixNativeScroll.applyMobileEnv(webix);

    if (testmode === 0) {
        webix.ajax().get(API_URL + "getUserData",
            {}
        )
            .then(function (res) {
                var response = JSON.parse(res.text());

                user.portalUser.userId = response.data.user_id;
                user.portalUser.role = response.data.usertype_id.ut_name;//response.data.role;
                user.portalUser.ut_level = response.data.ut_level;

                user.portalUser.login = response.data.login;
                user.portalUser.userFirstName = response.data.usr_firstname;
                user.portalUser.userLastName = response.data.usr_lastname;

                user.portalUser.projectId = response.data.project_id;
                user.portalUser.projectName = response.data.project_name;
                user.portalUser.enterpriseId = response.data.enterprise_id;
                user.portalUser.cardUid = response.data.usr_carduid;
                user.portalUser.timezone = response.data.timezone;
                user.portalUser.locale = response.data.locale;

                if(user.portalUser.locale)
                    APPLANG = locale.mapLanguage(user.portalUser.locale);

            })
            .then(function () {
                var startPage = sysFunc.getStartPageForRole(user.portalUser.role);

                app = core.create({
                    id: "app",
                    name: "IT App",
                    version: "0.1",
                    //debug: true,
                    start: startPage,
                });
                app.use(menu);

                if (APPLANG !== locale.getLang()) {
                    locale.setLang(APPLANG, true);
                }

                app.use(locale);
                app.use(theme);
                // _fixHeight() on body UI sets Touch.limit(false); restore documented limited mode.
                webixNativeScroll.limitTouch(webix);
            })
            .catch(function (res) {
                app = true;
                webix.ui(authorizeForm.$ui).show();
            })
            .finally(function () {
                if (!app) {
                    webix.ui(authorizeForm.$ui).show();
                    return null;
                }
                webixNativeScroll.limitTouch(webix);
                return app;
            });

    } else {

        user.portalUser.userId = '123';
        user.portalUser.role = 'admin';
        user.portalUser.login = 'test1238';
        user.portalUser.userFirstName = 'Ivan';


        app = core.create({
            id: "app",
            name: "IT App",
            version: "0.1",
            //debug: true,
            start: "/app/mainEnterprise"
        });
        app.use(menu);
        app.use(locale);
        app.use(theme);
        webixNativeScroll.limitTouch(webix);

        return app;
    }

});
